export var TextStyle_TextAlignment;
(function (TextStyle_TextAlignment) {
    /** AUTO - browser default, eqivalent to `initial` */
    TextStyle_TextAlignment["AUTO"] = "AUTO";
    /** LEFT - Left align */
    TextStyle_TextAlignment["LEFT"] = "LEFT";
    /** RIGHT - Right align */
    TextStyle_TextAlignment["RIGHT"] = "RIGHT";
    /** CENTER - Center align */
    TextStyle_TextAlignment["CENTER"] = "CENTER";
    /** JUSTIFY - Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextStyle_TextAlignment["JUSTIFY"] = "JUSTIFY";
    TextStyle_TextAlignment["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TextStyle_TextAlignment || (TextStyle_TextAlignment = {}));
export var Link_Target;
(function (Link_Target) {
    /** SELF - Opens the linked document in the same frame as it was clicked (this is default) */
    Link_Target["SELF"] = "SELF";
    /** BLANK - Opens the linked document in a new window or tab */
    Link_Target["BLANK"] = "BLANK";
    /** PARENT - Opens the linked document in the parent frame */
    Link_Target["PARENT"] = "PARENT";
    /** TOP - Opens the linked document in the full body of the window */
    Link_Target["TOP"] = "TOP";
    Link_Target["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Link_Target || (Link_Target = {}));
export var PluginContainerData_Alignment;
(function (PluginContainerData_Alignment) {
    /** CENTER - Center Alignment */
    PluginContainerData_Alignment["CENTER"] = "CENTER";
    /** LEFT - Left Alignment */
    PluginContainerData_Alignment["LEFT"] = "LEFT";
    /** RIGHT - Right Alignment */
    PluginContainerData_Alignment["RIGHT"] = "RIGHT";
    PluginContainerData_Alignment["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PluginContainerData_Alignment || (PluginContainerData_Alignment = {}));
export var PluginContainerData_Width_Type;
(function (PluginContainerData_Width_Type) {
    /** CONTENT - Width matches the content width */
    PluginContainerData_Width_Type["CONTENT"] = "CONTENT";
    /** SMALL - Small Width */
    PluginContainerData_Width_Type["SMALL"] = "SMALL";
    /** ORIGINAL - Width will match the original asset width */
    PluginContainerData_Width_Type["ORIGINAL"] = "ORIGINAL";
    /** FULL_WIDTH - coast-to-coast display */
    PluginContainerData_Width_Type["FULL_WIDTH"] = "FULL_WIDTH";
    PluginContainerData_Width_Type["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PluginContainerData_Width_Type || (PluginContainerData_Width_Type = {}));
//# sourceMappingURL=common.enums.js.map